import {
  Component,
  ElementRef,
  forwardRef,
  OnDestroy,
  OnInit,
  ViewChild,
  input
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  UntypedFormControl,
  ValidationErrors,
  Validator,
  Validators,
} from '@angular/forms';
import { Schema } from '../../../../core/_models/schema';
import { SchemaTranslations } from '../../../../shared/models/schema-translations';
import { AbstractControlValueAccessor } from '../../../../shared/abstract_control_value_accessor.abstract';
import { Subscription } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { IconComponent } from '@app/shared/components/icon/icon.component';


@Component({
  selector: 'app-property-single-enum',
  templateUrl: './property-single-enum.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => PropertySingleEnumComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => PropertySingleEnumComponent), multi: true },
  ],
  imports: [
    IconComponent,
    ReactiveFormsModule,
    TranslatePipe,
    ButtonsModule
],
})
export class PropertySingleEnumComponent extends AbstractControlValueAccessor implements OnInit, OnDestroy, Validator {
  public RADIO_TO_SELECT_BREAKPOINT = 3;
  @ViewChild('input') public input: ElementRef;
  public readonly controlName = input<string>(undefined!);
  public readonly properties = input<Schema>(undefined!);
  public readonly schemaTranslations = input<SchemaTranslations | null>(undefined!);
  public readonly errors = input<any>();
  public formControl = new UntypedFormControl(null);
  public isInteger = false;
  private formSub: Subscription;

  public ngOnInit(): void {
    this.formSub = this.formControl.valueChanges.subscribe(() => this.formControlChange());
    this.isInteger = this.properties().hasNumericValues(this.controlName());
  }

  public ngOnDestroy(): void {
    this.formSub.unsubscribe();
  }

  public writeValue(obj: any): void {
    this.formControl.patchValue(obj);
  }

  public validate(c: AbstractControl): ValidationErrors | any {
    return this.properties().isFieldRequired(this.controlName()) ? Validators.required(c) : null;
  }

  public focus(): void {
    this.input.nativeElement.focus();
  }

  private formControlChange(): void {
    const value = this.isInteger ? parseInt(this.formControl.value, 10) : this.formControl.value;
    this.onTouched();
    this.onChange(value);
  }
}
